import { useEffect, useState } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import SectionWrapper from '../../components/SectionWrapper/SectionWrapper';
import BusinessConfigurationForm from '../../components/Business/BusinessConfigurationForm';
import { useBusinessConfig } from '../../hooks/business/useBusinessConfig';
import { useTaxpayerCategory } from '../../hooks/useTaxpayerCategory';
import { useEconomicActivities } from '../../hooks/useEconomicActivities';
import BusinessConfigService from '../../services/business/BusinessConfigService';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const BusinessConfigPage = () => {
  // 🔹 Logo para ticket
  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [logoPreviewUrl, setLogoPreviewUrl] = useState<string>('');

  // 🔹 Logo para PDF
  const [pdfLogoFile, setPdfLogoFile] = useState<File | null>(null);
  const [pdfLogoPreviewUrl, setPdfLogoPreviewUrl] = useState<string>('');

  const { form, error, updateField, loadBusinessConfig, saveBusinessConfig } =
    useBusinessConfig();

  const { fetchTaxpayerCategoryDropdown, taxpayerCategoryDropdown } =
    useTaxpayerCategory();
  const { fetchEconomicActivitiesDropdown, economicActivitiesDropdown } =
    useEconomicActivities();

  // ✅ Inicializar datos
  useEffect(() => {
    const initialize = async () => {
      await loadBusinessConfig();
      await fetchTaxpayerCategoryDropdown();
      await fetchEconomicActivitiesDropdown();
    };
    initialize();
  }, []);

  // ✅ Cargar logo principal desde backend
  useEffect(() => {
    const fetchLogo = async () => {
      if (form.logoPath) {
        const logoUrl = await BusinessConfigService.getBusinessLogoUrl(form.logoPath);
        if (logoUrl) setLogoPreviewUrl(logoUrl);
      }
    };
    fetchLogo();
  }, [form.logoPath]);

  // ✅ Cargar logo PDF desde backend
  useEffect(() => {
    const fetchPdfLogo = async () => {
      if (form.pdfLogoPath) {
        const pdfLogoUrl = await BusinessConfigService.getBusinessLogoUrl(form.pdfLogoPath);
        if (pdfLogoUrl) setPdfLogoPreviewUrl(pdfLogoUrl);
      }
    };
    fetchPdfLogo();
  }, [form.pdfLogoPath]);

  // ✅ Handlers
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    const numericFields = [
      'taxpayerCategoryId',
      'economicActivityId',
    ];
    const parsedValue = numericFields.includes(name) ? Number(value) : value;
    updateField(name as keyof typeof form, parsedValue);
  };

  
  const handleEconomicActivitySelect = (option: { id: number; name: string }) => {
    updateField('economicActivityId', option.id);
  };

  const handleEconomicActivitySearch = async (text: string) => {
    await fetchEconomicActivitiesDropdown(text);
  };

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <BusinessConfigurationForm
          form={form}
          errors={error ? { general: error } : {}}
          logoFile={logoFile}
          logoPreviewUrl={logoPreviewUrl}
          setLogoFile={setLogoFile}
          pdfLogoFile={pdfLogoFile}
          pdfLogoPreviewUrl={pdfLogoPreviewUrl}
          setPdfLogoFile={setPdfLogoFile}
          onChange={handleChange}
          onEconomicActivitySelect={handleEconomicActivitySelect}
          onEconomicActivitySearch={handleEconomicActivitySearch}
          onSave={() => saveBusinessConfig(form, logoFile, pdfLogoFile)}
          taxpayerCategoryOptions={taxpayerCategoryDropdown}
          economicActivityOptions={economicActivitiesDropdown}
        />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default BusinessConfigPage;
